module.exports = __webpack_public_path__ + "img/inspiration_03.9c2459d.jpg";